import { DragSource } from 'react-dnd'
import React from 'react'

export class Breaker extends React.Component {
    constructor(props) {
        super(props)

        var opacity = this.props.isDragging ? 0.4 : 1

        this.state = {
            isDragging: opacity
        }
    }

    handleDeletingBreaker (itemID) {
        this.props.handleDeletingBreaker(itemID)
    }

    handleToggleBreakerFavourite (itemID, ParentBreakerTypeItemID) {
        this.props.handleToggleBreakerFavourite(itemID, ParentBreakerTypeItemID)
    }

    handleBreakerAutoAdd (itemID) {
        this.props.handleBreakerAutoAdd(itemID, this.props.quantity)
    }

    render() {
        const opacity = this.props.isDragging ? 0.4 : 1

        return (
        <div className={ 'breaker' + (this.props.isDisabled ? ' is-disabled' : '')} ref={ this.props.connectDragSource } style={{ opacity }}>
            <span className="breaker__number">{ this.props.usedCount }</span>
            <span className={ 'breaker__type breaker__type--' + this.props.poleCount }>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
            </span>
            <span className="breaker__title">
                { this.props.drawingDesc }

                {
                    this.props.isDisabled &&
                    <div className="breaker__subtitle">Cannot be fitted on to this board</div>
                }
            </span>
            <div className="breaker__actions">
                <button className="button--icon" onClick={ () => { this.handleDeletingBreaker(this.props.ItemID) } }>
                    <span className="button__icon">
                        <span className="i-trash-bin"></span>
                    </span>
                </button>
            
                <div className="checkbox-favourite favourite">
                    <input id={ 'fav-' + this.props.ItemID } className="favourite__input" type="checkbox" name={ 'fav-' + this.props.ItemID } 
                        checked={ this.props.isBreakerFavourite } 
                        onChange={ () => this.handleToggleBreakerFavourite(this.props.ItemID, this.props.ParentBreakerTypeItemID) } />

                    <label className="favourite__label" htmlFor={ 'fav-' + this.props.ItemID }>
                        <span className="i-favourite"></span>
                        <span className="i-favourite-selected"></span>
                    </label>
                </div>
                {!this.props.isDragAndDropEnabled && !this.props.isDisabled &&
                    <div className='breaker__quantity'>
                        <input className="input" type="number" value={ this.props.quantity } onChange={(e) => this.props.handleUpdateQuantity(e.target.value, this.props.ItemID)}  />
                    </div>
                }

                { !this.props.isDisabled && 
                    <button className="button button--outline button-auto-placement" disabled={this.props.quantity < 1}  onClick={ () => { this.handleBreakerAutoAdd(this.props.ItemID) } }>
                        <span className="button__icon">
                            <span className="i-plus"></span>
                        </span>
                    </button>
                }
            </div>
        </div>
        )
    }
}

export default DragSource('ChassisPole', 
    {
        beginDrag: (props) => {
            return { 
                ItemID: props.ItemID,
                BreakerTypeItemID: props.BreakerTypeItemID,
                poleCount: props.poleCount,
                ParentBreakerTypeItemID: props.ParentBreakerTypeItemID ?? 0
            }
        },
        endDrag(props, monitor) {
            const item = monitor.getItem()
            const dropResult = monitor.getDropResult() 
            if (dropResult) {
                // The previous existing system was UI depended and was passing +2 pole index for each element with pole count > 0
                // So, if you were passing a breaker on position 3, it will save it to the API at position 5 and visually with CSS shift it by negative -1 to the top
                // We keep this existing logic here to not need to refactor back end APIs

                let poleIndex = dropResult.poleIndex
                if (item.poleCount > 1) {
                    poleIndex = poleIndex + 2
                }

                props.addBreakerToBoard(poleIndex, item.ItemID, item.BreakerTypeItemID, item.ParentBreakerTypeItemID)
            }
        },
        canDrag(props) {
            return props.isDragAndDropEnabled && !props.isDisabled
        }
    }, 
    (connect, monitor) => {
        return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging()
        }
    }
)(Breaker)
